module.exports = __webpack_public_path__ + "img/f1_img.c6418df.png";